exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".chooselist li[data-v-66687203]{margin:0 10px 10px 0;position:relative}.chooselist li img[data-v-66687203]{width:40px;height:40px;border-radius:50%;overflow:hidden}.chooselist li .selectcolor[data-v-66687203]{position:absolute;width:16px;height:16px;bottom:0;right:0}.chooselist li[data-v-66687203]:first-child{border-radius:0}.logopath[data-v-66687203]{width:80px;height:80px;border-radius:50%;overflow:hidden;cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-66687203","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/packages/edituser/um-edituser.vue
// module id = 153
// module chunks = 0